import apiClient from '../index'

export const uploadRoster = (data) => apiClient.post('roster', data)
export const getRosterList = (skip, limit, searchEmp, month, year, locationId, extraParams = {}) =>
  apiClient.get('roster', {
    params: {
      skip,
      limit,
      searchEmp,
      month,
      year,
      locationId,
      ...extraParams,
    },
  })

export const generateAutoRoster = (data) => apiClient.post('roster/auto-generate', data)

export const getAutoRosterBatches = (
  { skip = 0, limit = 10, status, ...params } = {},
  options = {},
) =>
  apiClient.get('roster/list', {
    params: {
      skip,
      limit,
      status,
      ...params,
    },
    suppressErrorNotification: options?.silent,
  })

export const getEmployeeRosterBatches = (
  empId,
  { skip = 0, limit = 10, status, ...params } = {},
  options = {},
) =>
  apiClient.get(`roster/employee/${empId}`, {
    params: {
      skip,
      limit,
      status,
      ...params,
    },
    suppressErrorNotification: options?.silent,
  })

export const getRosterBatchDetails = (id, params = {}, options = {}) => {
  return apiClient.get(`roster/batch/${id}`, {
    params,
    suppressErrorNotification: options?.silent,
  })
}

export const getAutoRosterBatchDetails = (id) => getRosterBatchDetails(id)

export const publishAutoRosterBatch = (id) => apiClient.patch(`roster/auto-batches/${id}/publish`)

export const approveAutoRosterBatch = (id, data) =>
  apiClient.patch(`roster/auto-batches/${id}/approve`, data)

export const rejectAutoRosterBatch = (id, data) =>
  apiClient.patch(`roster/auto-batches/${id}/reject`, data)

export const discardAutoRosterBatch = (id, data) =>
  apiClient.delete(`roster/auto-batches/${id}`, { data })

export const getRosterBatchChanges = (id) => apiClient.get(`roster/batch/${id}/changes`)

export const approveRosterChangeRequest = (id) =>
  apiClient.patch(`roster/change-requests/${id}/approve`)

export const rejectRosterChangeRequest = (id, data) =>
  apiClient.patch(`roster/change-requests/${id}/reject`, data)

export const getAutoRosterSettings = () => apiClient.get('roster/auto-settings')

export const updateAutoRosterSettings = (data) => apiClient.patch('roster/auto-settings', data)
